import { render } from "./UserDeleteModal.vue?vue&type=template&id=5632dc70&scoped=true"
import script from "./UserDeleteModal.vue?vue&type=script&lang=js"
export * from "./UserDeleteModal.vue?vue&type=script&lang=js"

import "./UserDeleteModal.vue?vue&type=style&index=0&id=5632dc70&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5632dc70"]])

export default __exports__